
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { BookReservationRequest, BookReservationResponse } from '@/utils/a2a/types/schedulerTypes';
import { toast } from 'sonner';

export const useSchedulerReservations = () => {
  const [bookingStatus, setBookingStatus] = useState<'idle' | 'checking' | 'booking' | 'confirmed' | 'failed'>('idle');

  const bookReservation = async (request: BookReservationRequest): Promise<BookReservationResponse | null> => {
    try {
      setBookingStatus('checking');

      const { data: travelData, error: travelError } = await supabase.functions.invoke('scheduling/estimate-travel', {
        body: JSON.stringify({
          venue: request.venue,
          attendees: request.attendees.filter(a => a.location)
        })
      });

      if (travelError) throw travelError;
      setBookingStatus('booking');

      const { data: bookingData, error: bookingError } = await supabase.functions.invoke('scheduling/create-reservation', {
        body: JSON.stringify({
          ...request,
          travelEstimates: travelData.travelEstimates
        })
      });

      if (bookingError) throw bookingError;

      if (bookingData.status === 'confirmed' && request.addTravelBuffer) {
        const { data: calendarData, error: calendarError } = await supabase.functions.invoke('scheduling/create-with-travel', {
          body: JSON.stringify({
            reservation: bookingData,
            travelEstimates: travelData.travelEstimates
          })
        });

        if (calendarError) throw calendarError;

        if (calendarData?.eventIds) {
          bookingData.calendarEventIds = calendarData.eventIds;
        }
      }

      setBookingStatus('confirmed');
      toast.success('Reservation booked successfully');
      
      return bookingData;
    } catch (error) {
      console.error('Error booking reservation:', error);
      setBookingStatus('failed');
      toast.error('Failed to book reservation');
      return null;
    }
  };

  return {
    bookingStatus,
    bookReservation
  };
};
